export const portfolioCompanyConnectionConstants = {
  PORTFOLIO_COMPANY_CONNECTION_CREATE_LOADING: 'PORTFOLIO_COMPANY_CONNECTION_CREATE_LOADING',
  PORTFOLIO_COMPANY_CONNECTION_CREATE_SUCCESS: 'PORTFOLIO_COMPANY_CONNECTION_CREATE_SUCCESS',
  PORTFOLIO_COMPANY_CONNECTION_CREATE_FAILURE: 'PORTFOLIO_COMPANY_CONNECTION_CREATE_FAILURE',
  PORTFOLIO_COMPANY_CONNECTION_ERROR_RELOAD: 'PORTFOLIO_COMPANY_CONNECTION_ERROR_RELOAD',

  PORTFOLIO_COMPANY_CONNECTION_LIST_LOADING: 'PORTFOLIO_COMPANY_CONNECTION_LIST_LOADING',
  PORTFOLIO_COMPANY_CONNECTION_LIST_SUCCESS: 'PORTFOLIO_COMPANY_CONNECTION_LIST_SUCCESS',
  PORTFOLIO_COMPANY_CONNECTION_LIST_FAILURE: 'PORTFOLIO_COMPANY_CONNECTION_LIST_FAILURE',

  PORTFOLIO_COMPANY_CONNECTION_EDIT_LOADING: 'PORTFOLIO_COMPANY_CONNECTION_EDIT_LOADING',
  PORTFOLIO_COMPANY_CONNECTION_EDIT_SUCCESS: 'PORTFOLIO_COMPANY_CONNECTION_EDIT_SUCCESS',
  PORTFOLIO_COMPANY_CONNECTION_EDIT_FAILURE: 'PORTFOLIO_COMPANY_CONNECTION_EDIT_FAILURE',

  PORTFOLIO_COMPANY_CONNECTION_DELETE_LOADING: 'PORTFOLIO_COMPANY_CONNECTION_DELETE_LOADING',
  PORTFOLIO_COMPANY_CONNECTION_DELETE_SUCCESS: 'PORTFOLIO_COMPANY_CONNECTION_DELETE_SUCCESS',
  PORTFOLIO_COMPANY_CONNECTION_DELETE_FAILURE: 'PORTFOLIO_COMPANY_CONNECTION_DELETE_FAILURE'
};
